import { render, staticRenderFns } from "./keshavarzi.vue?vue&type=template&id=8906fd92"
import script from "./keshavarzi.vue?vue&type=script&lang=js"
export * from "./keshavarzi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports